import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  // Priority: admin > manager > customer
  const token = localStorage.getItem("dsf_admin_token")
    || localStorage.getItem("dsf_manager_token")
    || localStorage.getItem("dsf_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

// USD currency formatter
export const formatUSD = (amount) => {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount || 0);
};

// Backwards compatibility alias
export const formatFCFA = formatUSD;

// Resolve image url: full URL or relative /api/files/{id}
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export const universeLabel = (slug) => {
  const map = {
    street_food: "Dakar Street Food",
    street_market: "Dakar Market",
    food_truck: "Dakar Food Truck",
    dakar_events: "Dakar Events",
  };
  return map[slug] || slug;
};

export const statusLabel = (status) => {
  const map = {
    pending: "Pending",
    awaiting_acceptance: "Awaiting acceptance",
    confirmed: "Confirmed",
    paid: "Paid",
    preparing: "Preparing",
    ready: "Ready",
    delivering: "Delivering",
    delivered: "Delivered",
    cancelled: "Cancelled",
    rejected: "Rejected",
  };
  return map[status] || status;
};

export const deliveryLabel = (method) => {
  const map = {
    delivery: "Standard Delivery",
    click_collect: "Pickup",
    pickup_restaurant: "Pickup at restaurant",
    pickup_foodtruck: "Pickup at food truck",
    uber_eats: "Uber Eats",
    doordash: "DoorDash",
  };
  return map[method] || method;
};

export const paymentLabel = (method) => {
  const map = {
    visa: "Visa",
    mastercard: "Mastercard",
    paypal: "PayPal",
    installments: "Pay in 3 installments",
    pay_on_site: "Pay on site",
    stripe: "Card",
  };
  return map[method] || method;
};
